import { render, staticRenderFns } from "./goodsUnpackList.vue?vue&type=template&id=6ad3165a&"
import script from "./goodsUnpackList.vue?vue&type=script&lang=js&"
export * from "./goodsUnpackList.vue?vue&type=script&lang=js&"
import style0 from "./goodsUnpackList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports